import { HomeResponse } from 'data/homeHub/api';
import mockData, { mockWithMember } from 'data/homeHub/api/mock';
import { appToApi, apiToApp } from 'data/homeHub/api/serverApi';

// used to artificially delay the mocked response from the back-end.
const DELAY = 1000;

export const loadHomeHub = () => {
  return new Promise<HomeResponse>(resolve =>
    setTimeout(() => resolve(mockWithMember), DELAY),
  ).then(apiToApp);
};

export const onboardHomeHub = (onboardData: any) => {
  return new Promise<HomeResponse>(resolve =>
    setTimeout(
      () =>
        resolve({
          ...mockData,
          ...onboardData,
        }),
      DELAY,
    ),
  ).then(apiToApp);
};

export const changeHomeAddress = () => {
  return new Promise<HomeResponse>(resolve =>
    setTimeout(() => resolve(mockData), DELAY),
  ).then(apiToApp);
};

export const joinHomeHubWithAddress = () => {
  return new Promise<HomeResponse>(resolve =>
    setTimeout(() => resolve(mockData), DELAY),
  ).then(apiToApp);
};

export const removeFromHomeHub = () => {
  return new Promise<HomeResponse>(resolve =>
    setTimeout(() => resolve(mockData), DELAY),
  ).then(apiToApp);
};

export const changeParentalControl = () => {
  return new Promise<void>(resolve => setTimeout(() => resolve(), DELAY));
};

export { appToApi, apiToApp };
